import { combineReducers } from 'redux';

import { reducer as businessDetails } from '../Components/pages/businessdetails';
import { reducer as trustDetails } from '../Components/pages/locateyourtrust';
import { reducer as trusteeDetails } from '../Components/pages/locateyourtrustee';
import { reducer as mobileVerification } from '../Components/pages/mobileverification';
import { reducer as workflow } from '../Components/pages/steps';
import { reducer as mainPage } from '../Components/pages/main';
import { reducer as idVerification } from '../Components/pages/idverification';
import { reducer as captureDirector } from '../Components/pages/personaldetails';
import { reducer as banklink } from '../Components/pages/banklink';
import { reducer as mobileNumberSkipVerify } from '../Components/pages/mobilenumberskipverify';

const appReducer = combineReducers({
  businessDetails,
  trustDetails,
  trusteeDetails,
  mobileVerification,
  workflow,
  mainPage,
  captureDirector,
  idVerification,
  banklink,
  mobileNumberSkipVerify,
});

const rootReducer = (state, action) => {
  let appState = state;
  if (action.type.indexOf('GLOBAL_RESET') > -1) {
    appState = undefined;
  }

  return appReducer(appState, action);
};

export default rootReducer;
